<template>
    <div>
        <div :id="btnId"
            class=""
            :class="[{'disabled': isBtnDisable}, customClass()]">
            <div class="btn-txt"
                v-html="btnMsg"
                @click="clickButton"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Button',
    props: {
        btnId: String,
        btnMsg: String,
        isBtnDisable: Boolean,
        customStyle: String
    },
    methods: {
        clickButton: function () {
            if (this.isBtnDisable) return;

            this.$emit('clickButton');
        },
        customClass: function () {
            if (this.customStyle != null) {
                return this.customStyle;
            } else {
                return 'btn-wrapper';
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/input/BaseButton.scss';
.btn-wrapper {
    @include btn-wrapper();

    // @include mini-mobile(){
    //     min-height: 40px;
    // }
}

.confirm-btn-wrapper {
    @include btn-wrapper($margin-top: 0px);
}

#cancel_redeem_btn {
    background-color: $white;
    border: 2px solid $blue-gray;
    .btn-txt{
        color: $blue-gray;
    }

}
</style>
